export default {
  label: 'Pages',
  placeholder: 'All',
  selected: 'selected',
  selectedPlural: 'selected',
};
